import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import FastAvatar from '../../molecules/FastAvatar'
import { useSearchClients } from '../../../api/clients'
import { useAppContext } from '../../../redux/slices/appContext'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 6
  },
  name: {
    fontWeight: 600,
    fontSize: 13,
    color: 'var(--color-primary-600, #1565c0)',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200
  },
  empty: {
    fontSize: 12,
    color: 'var(--color-neutral-400, #aaa)',
    fontStyle: 'italic'
  }
}))

export default function ClientContextBadge () {
  const classes = useStyles()
  const { clientId } = useAppContext()

  const clientQuery = useMemo(() => ({
    filters: { clientId: clientId ? [clientId] : [] },
    includes: { avatars: true },
    take: 1
  }), [clientId])

  const { data: clientData } = useSearchClients(clientQuery, {
    enabled: !!clientId
  })

  const client = useMemo(() => (clientData?.data || []).at(0), [clientData])

  if (!clientId) {
    return <span className={classes.empty}>No client selected</span>
  }

  return (
    <div className={classes.root}>
      <FastAvatar
        avatarUrl={client?.avatarUrl}
        abbreviation={client?.clientAbbreviation}
        size='sm'
      />
      <span className={classes.name}>{client?.longName || client?.shortName || '...'}</span>
    </div>
  )
}
